module.exports = __webpack_public_path__ + "static/media/community-g.8acb4e90.svg";